import { useCallback, useState } from 'react';
import classNames from 'classnames';
import { Button, Checkbox } from 'antd';
import {
    config,
    prepareHubspotData,
    sendToAmplitude,
    sendToHubspot,
    useFormData
} from '../../model';
import s from './index.module.css';

const purposes = [
    {
        title: 'API Attack Surface Discovery',
        desc: 'Identifies external hosts and their APIs'
    },
    {
        title: 'API Leak Detection',
        desc: 'Scans public repositories to identify any leaked API secrets, including API Keys, PII, authorization tokens, and more'
    },
    {
        title: 'WAAP/WAF API Coverage',
        desc: 'Identifies hosts protected by WAF and determines which API threats the WAF can detect'
    },
    {
        title: 'API threat intelligence',
        desc: 'Information feed with the newest vulnerabilities related to APIs and remediation strategies'
    },
    {
        title: 'API vulnerability scanner',
        desc: 'Discovers API-related vulnerabilities from the external surface by sending unharmful malicious requests'
    }
];

export const Purpose = () => {
    const { email, nextStep } = useFormData();
    const [answer, setAnswer] = useState<string[]>([]);

    const handleBack = useCallback(() => {
        nextStep('solutions');
    }, []);

    const handleNext = useCallback(async () => {
        await Promise.all([
            sendToAmplitude(`WALLARMCOM_AASM_LOOKING_FOR_SUBMITTED`, {
                what_are_you_looking_for: answer
            }),
            sendToHubspot(
                prepareHubspotData({
                    email,
                    looking_for: answer.join(';')
                })
            )
        ]);

        window.location.href = `${config.siteURL}`;
    }, [email, answer]);

    return (
        <>
            <Checkbox.Group onChange={setAnswer}>
                <div className={s.block}>
                    {purposes.map(({ title, desc }) => (
                        <Checkbox
                            value={title}
                            key={title}
                            className={classNames(s.item, answer.includes(title) && s.checked)}
                            onClick={() =>
                                sendToAmplitude(`WALLARMCOM_AASM_LOOKING_FOR_LIST`, {
                                    checked: title
                                })
                            }
                        >
                            <div>
                                <div>{title}</div>
                                <div className={s.desc}>{desc}</div>
                            </div>
                        </Checkbox>
                    ))}
                </div>
            </Checkbox.Group>

            <div className={s.actions}>
                <Button size='large' onClick={handleBack}>
                    Back
                </Button>
                <Button
                    type='primary'
                    size='large'
                    htmlType='submit'
                    disabled={!answer.length}
                    onClick={handleNext}
                >
                    Let&apos;s see my scan results!
                </Button>
            </div>
        </>
    );
};
